import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import modalSpinner from "src/components/modalSpinner";
import NewItemButton from "src/components/NewItemButton";
import ProgressBar from "./ProgressBar";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { ReturnUseMission } from "./useMission";
import { CreateEditDisclosureProps } from "./useUIState";
import { useFreeTrialToast } from "src/store/hooks/useFreeTrialToast";
import FreeTrialLock from "src/components/FreeTrialLock";

type MissionsCreateProps = {
  disclosureProps: CreateEditDisclosureProps;
  missionProps: ReturnUseMission;
  shouldUserAddMission: boolean;
};

const PurposesCreate: React.FC<MissionsCreateProps> = ({
  disclosureProps,
  missionProps,
  shouldUserAddMission,
}) => {
  const [step, setStep] = useState(0);
  const nextStep = () => setStep((step) => step + 1);

  // for free trial users
  const { formatMessage } = useIntl();
  const { showFreeTrialToast } = useFreeTrialToast();
  const modalBody =
    step === 0 ? (
      <Step1 nextStep={nextStep} {...missionProps} />
    ) : step === 1 ? (
      <Step2 nextStep={nextStep} {...missionProps} />
    ) : step === 2 ? (
      <Step3 nextStep={nextStep} {...missionProps} />
    ) : step === 3 ? (
      <Step4 {...missionProps} />
    ) : null;

  useEffect(() => {
    //once it closes reset step to 0
    if (!disclosureProps.isOpen) setStep(0);
  }, [disclosureProps]);

  return (
    <>
      <Modal
        {...disclosureProps}
        onClose={() => {
          disclosureProps.onClose();
          setStep(0);
          missionProps.clear();
        }}
        scrollBehavior="outside"
      >
        <ModalOverlay />
        <ModalContent px={"10px"} borderRadius="30px" maxW="50rem" mt={"40px"}>
          <ModalHeader>
            <ModalCloseButton />
            <ProgressBar step={step} setStep={setStep} />
          </ModalHeader>
          <ModalBody>
            {disclosureProps.isEdit
              ? missionProps.missionLoading
                ? modalSpinner
                : modalBody
              : modalBody}
          </ModalBody>
        </ModalContent>
      </Modal>
      <FreeTrialLock isLocked={!shouldUserAddMission} lockSpacing={5}>
        <NewItemButton
          onClick={() => {
            if (!shouldUserAddMission) {
              showFreeTrialToast({
                message: formatMessage({
                  id: "freeTrial.missionsLimitReached",
                }),
              });
              return;
            }
            disclosureProps.onOpen(false, undefined);
          }}
        >
          <FormattedMessage
            id="missions.create"
            defaultMessage="إضافة مهمة جديدة"
          />
        </NewItemButton>
      </FreeTrialLock>
    </>
  );
};
export default PurposesCreate;
